import { Alert, AlertType } from '@design/components/alert/Alert';
import { useTranslation } from 'react-i18next';

export const SourcesUpdateAlert = () => {
  const { t } = useTranslation(['chat']);

  return (
    <Alert
      type={AlertType.Success}
      title={t('chat:trustedSources.updateSuccess')}
    />
  );
};
